document.querySelectorAll('[data-review-product]').forEach(async (list) => {
  if (list.dataset.loaded) return;
  list.dataset.loaded = 'true';
  const text = (tag, content, className) => {
    const element = document.createElement(tag);
    const decoded = new DOMParser().parseFromString(String(content || ''), 'text/html').body.textContent;
    element.textContent = decoded;
    if (className) element.className = className;
    return element;
  };
  try {
    const response = await fetch(`https://api-cdn.yotpo.com/v1/widget/EGrZ8aTOzP9E55lCrAqr1D5PEWNgrvUT90kSUxlG/products/${list.dataset.reviewProduct}/reviews.json?per_page=3&sort=date&direction=desc`);
    if (!response.ok) throw new Error('Reviews unavailable');
    const { response: data } = await response.json();
    data.reviews.forEach((review) => {
      const card = text('article', '', 'cryo-bundle-product__review');
      const stars = text('span', '★'.repeat(review.score) + '☆'.repeat(5 - review.score), 'cryo-bundle-product__review-score');
      stars.setAttribute('aria-label', `${review.score} out of 5 stars`);
      card.append(stars, text('h4', review.title), text('p', review.content));
      const labels = [review.user.display_name];
      if (review.verified_buyer) labels.push('Verified buyer');
      if (review.is_incentivized) labels.push('Incentivized review');
      card.append(text('p', labels.join(' · '), 'cryo-bundle-product__review-meta'));
      list.append(card);
    });
  } catch {
    list.append(text('p', 'Read customer reviews using the product link below.'));
  }
});
